import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { ROUTES, ADMIN_EMAIL } from '../constants';

export default function PublicRoute() {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated) {
    if (user?.email === ADMIN_EMAIL) {
      return <Navigate to={ROUTES.ADMIN_APPROVAL} replace />;
    }
    const redirectTo = user?.role === 'owner' ? ROUTES.HORSE_OWNER_HOME : ROUTES.HORSE_RIDER_HOME;
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
}
